import { localize } from "@/i18n/translate";
import { Loader2 } from "lucide-react";
const TICKET_CLS = {
  neu: "bg-signal text-white",
  in_bearbeitung: "bg-ink text-paper",
  wartet_auf_kunde: "border border-signal text-signaldark",
  abgeschlossen: "border border-ink/25 text-mute"
};
const USER_CLS = {
  pending: "border border-signal text-signaldark",
  approved: "bg-ink text-paper",
  rejected: "border border-ink/25 text-mute"
};
export const Badge = ({
  kind = "ticket",
  value,
  label,
  testId
}) => <span data-testid={testId} className={`inline-flex items-center whitespace-nowrap px-2.5 py-1 font-mono text-[11px] uppercase tracking-[0.12em] ${(kind === "ticket" ? TICKET_CLS : USER_CLS)[value] || "border border-ink/25"}`}>
    {localize(label)}
  </span>;
export const PageTitle = ({
  eyebrow,
  title,
  children
}) => <div className="flex flex-col gap-6 border-b border-ink/15 pb-8 md:flex-row md:items-end md:justify-between">
    <div>
      {localize(eyebrow && <p className="eyebrow">{localize(eyebrow)}</p>)}
      <h1 className="mt-3 font-display text-3xl font-extrabold leading-[1.02] tracking-[-0.03em] sm:text-4xl lg:text-5xl">{localize(title)}</h1>
    </div>
    {localize(children)}
  </div>;
export const Spinner = ({
  label
}) => <div role="status" className="flex items-center gap-3 py-16 text-mute">
    <Loader2 className="h-5 w-5 animate-spin" aria-hidden="true" />
    {localize(label)}
  </div>;
export const ErrorNote = ({
  children,
  testId
}) => children ? <p role="alert" data-testid={testId} className="border-l-2 border-signal bg-signal/5 p-4 text-sm text-signaldark">
      {localize(children)}
    </p> : null;
export const btnPrimary = "inline-flex items-center justify-center gap-2 bg-signal px-6 py-3.5 font-medium text-white transition-colors hover:bg-signaldark disabled:opacity-60";
export const btnSecondary = "inline-flex items-center justify-center gap-2 border border-ink px-5 py-3 text-sm font-medium text-ink transition-colors hover:bg-ink hover:text-paper disabled:opacity-60";
export const inputCls = err => `mt-2 block w-full border bg-white/70 px-4 py-3 text-base text-ink placeholder:text-zinc-500 focus:outline-none focus-visible:outline-2 focus-visible:outline-signal ${err ? "border-signal" : "border-ink/25 focus:border-ink"}`;
export const FormField = ({
  id,
  label,
  error,
  hint,
  children
}) => <div>
    <label htmlFor={id} className="flex items-baseline justify-between gap-3 text-sm font-medium text-ink">
      {localize(label)}
      {localize(hint && <span className="font-mono text-xs font-normal text-mute">{localize(hint)}</span>)}
    </label>
    {localize(children)}
    {localize(error && <p id={`${id}-error`} data-testid={`${id}-error`} className="mt-2 text-sm text-signaldark">
        {localize(error)}
      </p>)}
  </div>;
